<template>
  <div id="app">
    <!-- <div class="header">Email Signature/Template Generator</div>
    <div>(Please fill out the form to automatically generate a signature)</div> -->
    <div class="header">{{ headerText }}</div>
    <div>{{ subHeaderText }}</div>
    <div class="main">
      <el-form ref="form" :model="form" label-width="80px" label-position="top">
        <el-form-item label="Choose Template">
          <el-cascader v-model="form.templateValue" :options="template" @change="handleTemplateChange"></el-cascader>
        </el-form-item>
      </el-form>
      <el-form v-if="selectedTemplateIndex === 5" label-width="80px" label-position="top">
        <el-form-item label="Choose Business">
          <el-select v-model="selectedBusinessCard" placeholder="Choose Business">
            <el-option v-for="item in businessCardOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form ref="form" :model="form" label-width="80px" label-position="top" v-show="showSignature">
        <el-form-item label="Choose Business">
          <el-cascader v-model="form.value" :options="options" @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="Name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Position">
          <el-input v-model="form.position"></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="Phone Number	">
          <el-input v-model="form.telephone"></el-input>
        </el-form-item>
        <el-form-item label="Short Number">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="For Brokers Only" class="s_transfer">
          <el-transfer v-model="value" :data="transData" :titles="['Office Location', 'selected']">
          </el-transfer>
        </el-form-item>
        <i class="fas fa-share" style="
            font-size: 35px;
            position: absolute;
            top: 40%;
            right: -25px;
            color: #b8b8b8;
          "></i>
      </el-form>
      <el-form ref="form" :model="form" label-width="80px" label-position="top"
        v-show="selectedTemplateIndex > 1 && selectedTemplateIndex < 5">
        <el-form-item label="Broker Name" v-show="!birthdayEDM">
          <el-input v-model="ccEDMForm.brokerName"></el-input>
        </el-form-item>
        <el-form-item label="Client Name">
          <el-input v-model="ccEDMForm.clientName"></el-input>
        </el-form-item>
        <el-form-item label="Settled Date" v-show="!birthdayEDM">
          <el-date-picker v-model="ccEDMForm.settledDate" type="date" value-format="dd/MM/yyyy"></el-date-picker>
        </el-form-item>
      </el-form>

      <component :is="selectedBusinessCardComponent" v-if="selectedTemplateIndex === 5"></component>

      <i v-if="selectedTemplateIndex !== 5" class="fas fa-arrow-down" style="font-size: 35px; color: #b8b8b8"></i>

      <div id="cutSection1" v-if="selectedTemplateIndex === 1"
        style="display: flex;flex-direction: column; align-items: center;">
        <table id="showSection" style="width: 900px;font-family: Aptos; ">
          <tr>
            <td>
              <div>
                <div style="font-size: 14.5px;">Best Regards,</div>
                <br>
                <div
                  data-name-container
                  :style="signatureNameStyle"
                >
                  {{ form.name }}
                </div>
                <div
                  data-position-container
                  :style="signaturePositionStyle"
                >
                  {{ form.position }}
                </div>
                <img v-if="!isWholesaleFundingGroup" :src="signatureLogo" />
                <table v-if="isWholesaleFundingGroup" data-wfg-contact-table cellpadding="0" cellspacing="0" border="0"
                  style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                  <tr>
                    <td data-wfg-icon-cell style="padding: 0; width: 18.39px; vertical-align: middle;">
                      <img data-wfg-icon="phone" :src="signatureIcons.phone" :style="wholesaleIconStyle"
                        v-bind="wholesaleIconAttrs" />
                    </td>
                    <td data-wfg-contact-cell style="padding: 0 0 0 3px; vertical-align: middle;">
                      <span data-wfg-contact="phone" :style="signaturePhoneTextStyle">{{ form.telephone }} / {{ form.mobile }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td data-wfg-icon-cell style="padding: 0; width: 18.39px; vertical-align: middle;">
                      <img data-wfg-icon="email" :src="signatureIcons.email" :style="wholesaleIconStyle"
                        v-bind="wholesaleIconAttrs" />
                    </td>
                    <td data-wfg-contact-cell style="padding: 0 0 0 3px; vertical-align: middle;">
                      <span data-wfg-contact="email" :style="signatureContactTextStyle">{{ form.email }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td data-wfg-icon-cell style="padding: 0; width: 18.39px; vertical-align: middle;">
                      <img data-wfg-icon="website" :src="signatureIcons.website" :style="wholesaleIconStyle"
                        v-bind="wholesaleIconAttrs" />
                    </td>
                    <td data-wfg-contact-cell style="padding: 0 0 0 3px; vertical-align: middle;">
                      <a data-wfg-contact="website" :style="signatureWebsiteTextStyle" :href="'https://' + website"
                        target="_blank">{{ website }}</a>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in signatureAddresses" :key="index">
                    <td data-wfg-icon-cell style="padding: 0; width: 18.39px; vertical-align: middle;">
                      <img data-wfg-icon="map" :src="signatureIcons.map" :style="wholesaleIconStyle"
                        v-bind="wholesaleIconAttrs" />
                    </td>
                    <td data-wfg-contact-cell style="padding: 0 0 0 3px; vertical-align: middle;">
                      <span data-wfg-contact="address" :style="signatureContactTextStyle">{{ item }}</span>
                    </td>
                  </tr>
                  <tr v-if="showCreditLicense">
                    <td data-wfg-icon-cell style="padding: 0; width: 18.39px; vertical-align: middle;">
                      <img data-wfg-icon="document" :src="signatureIcons.document" :style="wholesaleIconStyle"
                        v-bind="wholesaleIconAttrs" />
                    </td>
                    <td data-wfg-contact-cell style="padding: 0 0 0 3px; vertical-align: middle;">
                      <span data-wfg-contact="credit-license" :style="signatureContactTextStyle">Australian Credit Licence No. {{ creditLicense }}</span>
                    </td>
                  </tr>
                </table>
                <template v-else>
                  <div>
                    <img :src="signatureIcons.phone" :style="wholesaleIconStyle" v-bind="wholesaleIconAttrs" />
                    <span :style="signaturePhoneTextStyle">{{ form.telephone }} | {{ form.mobile + '&nbsp;' }}</span>
                    <img :src="signatureIcons.website" :style="wholesaleIconStyle" v-bind="wholesaleIconAttrs" />
                    <!-- <span>&nbsp;</span> -->
                    <a :style="signatureWebsiteTextStyle" :href="'https://' + website" target="_blank">{{ website }}</a>
                  </div>
                  <div v-for="(item, index) in signatureAddresses" :key="index" style="">
                    <img :src="signatureIcons.map" :style="wholesaleIconStyle" v-bind="wholesaleIconAttrs" />
                    <span :style="signatureContactTextStyle">{{ item }}</span>
                  </div>
                  <div v-if="showCreditLicense">
                    <img :src="signatureIcons.document" :style="wholesaleIconStyle" v-bind="wholesaleIconAttrs" />
                    <span :style="signatureContactTextStyle">Australian Credit Licence No. {{ creditLicense }}</span>
                  </div>
                </template>
              </div>
            </td>
          </tr>
          <tr v-if="!isWholesaleFundingGroup">
            <div style="font-size: 6px;">&nbsp;</div>
          </tr>
          <tr v-if="showBanner">
            <td colspan="2">
              <div style="width: 100%; ">
                <img :src="showBanner" />
              </div>
            </td>
          </tr>
          <tr v-if="isWholesaleFundingGroup">
            <td colspan="2">
              <img data-wfg-logo :src="signatureLogo" width="700"
                style="width: 700px; max-width: 700px; height: auto; display: block; border: 0;" />
            </td>
          </tr>
        </table>

        <el-button class="copy-button" style="width: 300px; font-size: 20px; margin-top: 20px;"
          @click="copyEmailSignature">
          Copy Email Signature
        </el-button>
      </div>
      <div id="cutSection2" v-if="selectedTemplateIndex === 2"
        style="display: flex;flex-direction: column; align-items: center;">
        <div id="showSection" style="width: 600px;font-family: Aptos; ">
          <div aria-roledescription="email" role="article" lang="und" dir="auto">
            <div class="bg-section" style="margin:0px auto;max-width:600px;">
              <div style="line-height:0;font-size:0;">
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
                  style="background-color:#E7D1BC;width:100%;">
                  <tbody>
                    <tr>
                      <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                        <div class="mj-column-per-100 mj-outlook-group-fix"
                          style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
                            <tbody>
                              <tr>
                                <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                    style="border-collapse:collapse;border-spacing:0px;">
                                    <tbody>
                                      <tr>
                                        <td style="width:200px;"><img src="/cc_edm/logo.png"
                                            style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;"
                                            width="550" height="auto"></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td style="vertical-align:top;padding: 0px 40px;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%"
                                    style="background-color: #EAE9E7;">
                                    <tbody>
                                      <tr>
                                        <td align="left"
                                          style="font-size:0px;padding: 30px 25px 10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            Dear Mr\Ms {{ ccEDMForm.clientName }}.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            Thank you for choosing Award Mortgage. We would like to welcome and
                                            congratulate you on your recent Loan settlement with Broker {{
                                              ccEDMForm.brokerName }} on {{ ccEDMForm.settledDate }}.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            感谢您选择澳华信贷，恭喜您的贷款在Broker {{ ccEDMForm.brokerName }}跟进下在{{
                                              ccEDMForm.settledDate }}完成了交割。
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            We offer our services throughout the duration of the loan (and ever
                                            beyond!). This includes but is not limited to online or mobile banking
                                            access, statement requests, form requests and more.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            我们将竭诚为您服务，提供包括贷款、网银设置、申请流水等一站式解决方案。</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            lf you need more benefits or annual fee waiver, please contact us. If your
                                            complaints, opinions or suggestions are adopted, we will offer equivalent
                                            compensation or rewards worth no less than <span style="color:#8B4513;">100
                                              Australian Dollars (AUD)</span>.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            如需更多优惠或免年费，欢迎联系我们;<br>您的投诉、意见或建议若被采纳，我们将给予不低于<span
                                              style="color:#8B4513;">100澳币</span>的等价赔偿或奖励。</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="center" style="font-size:0px;word-break:break-word;">
                                          <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                            style="border-collapse:collapse;border-spacing:0px;">
                                            <tbody>
                                              <tr>
                                                <td style="width:550px;"><img src="/cc_edm/footer.png"
                                                    style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;"
                                                    width="550" height="auto"></td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left"
                                          style="font-size:0px;padding: 10px 25px 30px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            Kindly Regards,<br>Award Mortgage Solutions<br></div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <el-button class="copy-button" style="width: 300px; font-size: 20px; margin-top: 20px;"
          @click="copyEmailSignature">
          Copy Email Signature
        </el-button>
      </div>
      <div id="cutSection3" v-if="selectedTemplateIndex === 3"
        style="display: flex;flex-direction: column; align-items: center;">
        <div id="showSection" style="width: 600px;font-family: Aptos; ">
          <div aria-roledescription="email" role="article" lang="und" dir="auto">
            <div class="bg-section" style="margin:0px auto;max-width:600px;">
              <div style="line-height:0;font-size:0;">
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
                  style="background-color:#36539F;width:100%;">
                  <tbody>
                    <tr>
                      <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                        <div class="mj-column-per-100 mj-outlook-group-fix"
                          style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
                            <tbody>
                              <tr>
                                <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                    style="border-collapse:collapse;border-spacing:0px;">
                                    <tbody>
                                      <tr>
                                        <td style="width:200px;"><img src="/cc_edm_wfg/logo.png"
                                            style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;"
                                            width="550" height="auto"></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td style="vertical-align:top;padding: 0px 40px;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
                                    <tbody>
                                      <tr>
                                        <td align="left"
                                          style="font-size:0px;padding: 30px 25px 10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#FFFFFF;">
                                            Dear Mr\Ms {{ ccEDMForm.clientName }}.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#FFFFFF;">
                                            Thank you for choosing Wholesale Funding Group. We would like to welcome and
                                            congratulate you on your recent Loan settlement with Broker {{
                                              ccEDMForm.brokerName }} on {{ ccEDMForm.settledDate }}.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#FFFFFF;">
                                            感谢您选择澳华优贷，恭喜您的贷款在Broker {{ ccEDMForm.brokerName }}跟进下在{{
                                              ccEDMForm.settledDate }}完成了交割。
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#FFFFFF;">
                                            We offer our services throughout the duration of the loan (and ever
                                            beyond!). This includes but is not limited to online or mobile banking
                                            access, statement requests, form requests and more.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#FFFFFF;">
                                            我们将竭诚为您服务，提供包括贷款、网银设置、申请流水等一站式解决方案。</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#FFFFFF;">
                                            lf you need more benefits or annual fee waiver, please contact us. If your
                                            complaints, opinions or suggestions are adopted, we will offer equivalent
                                            compensation or rewards worth no less than <span
                                              style="font-weight: bold;">100
                                              Australian Dollars (AUD)</span>.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#FFFFFF;">
                                            如需更多优惠或免年费，欢迎联系我们;<br>您的投诉、意见或建议若被采纳，我们将给予不低于<span
                                              style="font-weight: bold;">100澳币</span>的等价赔偿或奖励。</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="center" style="font-size:0px;word-break:break-word;">
                                          <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                            style="border-collapse:collapse;border-spacing:0px;">
                                            <tbody>
                                              <tr>
                                                <td style="width:550px;"><img src="/cc_edm_wfg/footer.png"
                                                    style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;"
                                                    width="550" height="auto"></td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left"
                                          style="font-size:0px;padding: 10px 25px 30px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#FFFFFF;">
                                            Kindly Regards,<br>Wholesale Funding Group<br></div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <el-button class="copy-button" style="width: 300px; font-size: 20px; margin-top: 20px;"
          @click="copyEmailSignature">
          Copy Email Signature
        </el-button>
      </div>
      <div id="cutSection4" v-if="selectedTemplateIndex === 4"
        style="display: flex;flex-direction: column; align-items: center;">
        <div id="showSection" style="width: 600px;font-family: Aptos; ">
          <div aria-roledescription="email" role="article" lang="und" dir="auto">
            <div class="bg-section" style="margin:0px auto;max-width:600px;">
              <div style="line-height:0;font-size:0;">
                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
                  style="background-color:#EDDDB9;width:100%;">
                  <tbody>
                    <tr>
                      <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                        <div class="mj-column-per-100 mj-outlook-group-fix"
                          style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
                            <tbody>
                              <tr>
                                <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                    style="border-collapse:collapse;border-spacing:0px;">
                                    <tbody>
                                      <tr>
                                        <td style="width:200px;"><img src="/cc_edm/logo.png"
                                            style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;"
                                            width="550" height="auto"></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td style="vertical-align:top;padding: 0px 40px;">
                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%">
                                    <tbody>
                                      <tr>
                                        <td align="left"
                                          style="font-size:0px;padding: 30px 25px 10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            Dear Mr\Ms {{ ccEDMForm.clientName }}.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            Thank you for choosing Award Mortgage. On your special birthday, we send our
                                            sincere blessings to you.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            感谢您选择澳华信贷，值此生日良辰，我们向您致以最诚挚的祝福。
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            We offer our services throughout the duration of the loan (and ever
                                            beyond!). This includes but is not limited to online or mobile banking
                                            access,statement requests, form requests and more.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            我们将竭诚为您服务，提供包括贷款、网银设置、申请流水等一站式解决方案。</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            If you need more benefits or annual fee waiver, please contact us.</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            如需更多优惠或免年费，欢迎联系我们。</div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="center" style="font-size:0px;word-break:break-word;">
                                          <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                                            style="border-collapse:collapse;border-spacing:0px;">
                                            <tbody>
                                              <tr>
                                                <td style="width:550px;"><img src="/cc_edm_birthday/footer.png"
                                                    style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;"
                                                    width="550" height="auto"></td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td align="left"
                                          style="font-size:0px;padding: 10px 25px 30px 25px;word-break:break-word;">
                                          <div
                                            style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:14px;line-height:1.2;text-align:left;color:#000000;">
                                            Kindly Regards,<br>Award Mortgage Solutions<br></div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <el-button class="copy-button" style="width: 300px; font-size: 20px; margin-top: 20px;"
          @click="copyEmailSignature">
          Copy Email Signature
        </el-button>
      </div>

    </div>
  </div>
</template>

<script>
import "@fortawesome/fontawesome-free/css/all.css";
import AwardMortgageBusinessCard from '@/components/AwardMortgageBusinessCard.vue';
import GlobalRealtyBusinessCard from '@/components/GlobalRealtyBusinessCard.vue';

export default {
  name: "App",
  components: {
    AwardMortgageBusinessCard,
    GlobalRealtyBusinessCard,
  },
  data() {
    const office = [
      {
        location:
          "Sydney Headquarter: Level 3, 370 Pitt Street, Sydney, NSW 2000",
        office: "Sydney",
        src: "https://i.postimg.cc/cHkSx9Qn/AMS-LOGO-30.png",
      },
      {
        location:
          "Melbourne Headquarter: Level 3, 171 La Trobe Street, Melbourne VIC 3000",
        office: "Melbourne",
        src: "https://i.postimg.cc/d3XwBH3Y/AMS-LOGO-21.png",
      },
      {
        location:
          "Point Cook office: Shop 426, 2 Main Rd, Stockland Point Cook Town Centre",
        office: "Point Cook",
        src: "https://i.postimg.cc/t4Fp3zHK/AMS-LOGO-26.png",
      },
      {
        location:
          "Epping office: Ground Level, 38 Beecroft Road, Epping NSW 2121",
        office: "Epping",
        src: "https://i.postimg.cc/XqD7PN2t/AMS-LOGO-13.png",
      },
      {
        location:
          "Box Hill office: 724A Station Street, Box Hill, VIC 3128",
        office: "Box Hill",
        src: "https://i.postimg.cc/9X14TCBd/AMS-LOGO-02.png",
      },
      {
        location:
          "Brisbane office: 7B, 50-56 Sanders Street, Brisbane",
        office: "Brisbane",
        src: "https://i.postimg.cc/7YfL27h4/AMS-LOGO-14.png",
      },
      {
        location:
          "Canberra office: 411&412, Level 4, 15 Moore Street, Canberra ACT 2601",
        office: "Canberra",
        src: "https://i.postimg.cc/mg1h0MWj/AMS-LOGO-05.png",
      },
      {
        location: "Eastwood office: Suite 107, 160 Rowe Street, Eastwood",
        office: "Eastwood",
        src: "https://i.postimg.cc/wxWvMF6F/AMS-LOGO-12.png",
      },
      {
        location:
          "Burwood office: Suite A, Level 3,5 Belmore Street, Burwood NSW 2134",
        office: "Burwood",
        src: "https://i.postimg.cc/vHNcqhkD/AMS-LOGO-04.png",
      },
      {
        location: "MQ Park office: Suite G1, 64 Talavera Rd, Macquarie Park, NSW 2113",
        office: "MQ Park",
        src: "https://i.postimg.cc/nLYVJGR4/AMS-LOGO-18.png",
      },
    ];
    const generateData = () => {
      const data = [];

      office.forEach((city) => {
        if (city.office != "Central Management")
          data.push({
            label: city.office,
            key: city.location,
          });
      });
      return data.sort((a, b) => a.label.localeCompare(b.label));
    };

    return {
      headerText: "Email Signature/Template Generator",
      subHeaderText:
        "(Please fill out the form to automatically generate a signature)",
      showLogo: "logo/Award Global",
      showBanner: "",
      socials: [
        {
          from: "linkedin",
          href: "https://www.linkedin.com/company/award-global",
          iconclass: "fab fa-linkedin",
        },
        {
          from: "youtube",
          href: "https://www.youtube.com/@awardglobal6432",
          iconclass: "fab fa-youtube",
        },
      ],
      ACL: "387443",
      form: {
        value: [],
        templateValue: ["General"],
        name: "John Doe",
        position: "Company Position",
        email: "johndoe@awardglobal.com.au",
        telephone: "02 8088 0688",
        mobile: "2888",
      },
      template: [
        { label: "General", value: "General" },
        { label: "CC EDM", value: "CC EDM" },
        { label: "CC EDM WFG", value: "CC EDM WFG" },
        { label: "CC EDM BIRTHDAY", value: "CC EDM BIRTHDAY" },
        { label: "Marketing Business Card", value: "MKT SALES CARD" },
      ],
      selectedBusinessCard: "awardMortgage",
      businessCardOptions: [
        { label: "Award Mortgage", value: "awardMortgage" },
        { label: "Global Realty", value: "globalRealty" },
      ],
      selectedTemplateIndex: 1,
      website: "www.awardglobal.com.au",
      business: [
        {
          name: "AMS LAWYERS",
          logo: "https://awardglobal.com.au/wp-content/uploads/2023/06/amsl.png",
          size: "180 10",
          link: "https://www.amslawyers.com.au/",
          banner:
            "https://awardglobal.com.au/wp-content/uploads/2023/06/Lawyers-1.jpg",
          bannerSize: "700 150",
        },
        // {
        //   name: "Luxe Vista",
        //   logo: "https://awardglobal.com.au/wp-content/uploads/2024/04/Vista.png",
        //   size: "180 10",
        // },
        {
          name: "Award Global",
          logo: "https://awardglobal.com.au/wp-content/uploads/2023/06/award-global.png",
          size: "200 10",
          anniversary: true,
          socials: [
            {
              from: "linkedin",
              href: "https://www.linkedin.com/company/award-global",
              iconclass: "fab fa-linkedin",
            },
            {
              from: "youtube",
              href: "https://www.youtube.com/@awardglobal6432",
              iconclass: "fab fa-youtube",
            },
          ],
          link: "www.awardglobal.com.au",
        },
        {
          name: "Award Capital",
          logo: "https://www.awardglobal.com.au/wp-content/uploads/2023/05/Award-Capital-logo.png",
          size: "240 80",
          anniversary: true,
          link: "https://www.awardcapital.com.au/",
        },
        {
          name: "Award Mortgage",
          logo: "https://awardglobal.com.au/wp-content/uploads/2023/06/award-mortgage.png",
          credit: "387 443",
          size: "220 60",
          socials: [
            {
              from: "linkedin",
              href: "https://www.linkedin.com/company/awardmortgage/mycompany/",
              iconclass: "fab fa-linkedin",
            },
            {
              from: "facebook",
              href: "https://www.facebook.com/AwardMortgage.Loans",
              iconclass: "fab fa-facebook",
            },
            {
              from: "youtube",
              href: "https://www.youtube.com/@awardmortgage5383",
              iconclass: "fab fa-youtube",
            },
            {
              from: "redbook",
              href: "https://www.xiaohongshu.com/user/profile/631ee98d000000002303ff55?xhsshare=WeixinSession&appuid=631ee98d000000002303ff55&apptime=1683166292",
            },
          ],
          anniversary: true,
          link: "www.awardmortgage.com.au",
        },
        {
          name: "Global Realty",
          logo: "https://awardglobal.com.au/wp-content/uploads/2023/06/gr-1.png",
          size: "180 60",
          anniversary: true,
          socials: [
            {
              from: "facebook",
              href: "https://www.facebook.com/profile.php?id=100063847943543",
              iconclass: "fab fa-facebook",
            },
            {
              from: "youtube",
              href: "https://www.youtube.com/channel/UCJ0AUp3WoSY1hdkeJKzWlKQ",
              iconclass: "fab fa-youtube",
            },
            {
              from: "redbook",
              href: "https://www.xiaohongshu.com/user/profile/55d6ebd05894463b380aa4af?",
            },
          ],
          link: "www.globalrealty.com.au",
          bannerSize: "700 150",
        },
        {
          name: "Metro Award",
          anniversary: true,
          logo: "https://www.awardglobal.com.au/wp-content/uploads/2023/05/澳华国际房地产logo_复制-01-011.png",
          size: "200 60",
          link: "www.metroawardgroup.com.au",
        },
        {
          name: "Wholesale Funding Group",
          logo: "https://awardglobal.com.au/wp-content/uploads/2023/06/wfg.png",
          credit: "389 308",
          size: "180 60",
          socials: [
            {
              from: "linkedin",
              href: "https://www.linkedin.com/company/wholesale-funding/",
              iconclass: "fab fa-linkedin",
            },
          ],
          link: "www.wholesalefunding.com.au",
        },
      ],
      office: office,
      options: [
        {
          value: "AMS LAWYERS",
          label: "AMS LAWYERS",
        },
        {
          value: "Award Global",
          label: "Award Global",
        },
        {
          value: "Award Capital",
          label: "Award Capital",
        },
        {
          value: "Award Mortgage",
          label: "Award Mortgage",
        },
        {
          value: "Global Realty",
          label: "Global Realty",
        },
        // {
        //   value: "Luxe Vista",
        //   label: "Luxe Vista",
        // },
        {
          value: "Metro Award",
          label: "Metro Award",
        },
        {
          value: "Wholesale Funding Group",
          label: "Wholesale Funding Group",
        },
      ],
      transData: generateData(),
      value: ["Sydney Headquarter: Level 3, 370 Pitt Street, Sydney, NSW 2000", "Melbourne Office: Level 3, 171 La Trobe Street Melbourne VIC 3000"],
      showSignature: true,
      birthdayEDM: false,
      ccEDMForm: {
        clientName: "",
        brokerName: "",
        settledDate: "",
      },
    };
  },

  computed: {
    isWholesaleFundingGroup() {
      return this.form.value[0] === "Wholesale Funding Group";
    },
    signatureLogo() {
      return require(`@/assets/${this.showLogo}.png`);
    },
    signatureNameStyle() {
      if (this.isWholesaleFundingGroup) {
        return {
          fontFamily: "Segoe UI",
          fontSize: "14pt",
          fontWeight: "bold",
          color: "#234193",
        };
      }

      return {
        fontSize: "15.5px",
        fontWeight: "bold",
        color: "#000000",
      };
    },
    signaturePositionStyle() {
      if (this.isWholesaleFundingGroup) {
        return {
          fontFamily: "Segoe UI",
          fontSize: "11pt",
          fontWeight: "normal",
          color: "#000000",
          textDecoration: "none",
        };
      }

      return {
        fontSize: "14.5px",
      };
    },
    signatureContactTextStyle() {
      if (this.isWholesaleFundingGroup) {
        return {
          fontFamily: "Segoe UI",
          fontSize: "11pt",
          fontWeight: "normal",
          color: "#000000",
        };
      }

      return {
        fontSize: "14px",
      };
    },
    signaturePhoneTextStyle() {
      if (this.isWholesaleFundingGroup) {
        return {
          fontFamily: "Segoe UI",
          fontSize: "11pt",
          fontWeight: "bold",
          color: "#555555",
          verticalAlign: "middle",
        };
      }

      return {
        fontSize: "14px",
      };
    },
    signatureWebsiteTextStyle() {
      if (this.isWholesaleFundingGroup) {
        return {
          fontFamily: "Segoe UI",
          fontSize: "11pt",
          fontWeight: "normal",
          color: "#000000",
          textDecoration: "none",
          verticalAlign: "middle",
        };
      }

      return {
        fontSize: "14px",
        color: "#0000EE",
      };
    },
    wholesaleIconStyle() {
      if (!this.isWholesaleFundingGroup) {
        return null;
      }

      return {
        width: "18.39px",
        display: "inline-block",
        verticalAlign: "middle",
        // height: "auto",
        // marginRight: "3px",
      };
    },
    wholesaleIconAttrs() {
      if (!this.isWholesaleFundingGroup) {
        return {};
      }

      return {
        width: 18.39,
      };
    },
    signatureAddresses() {
      const wholesaleOnlyAddress = "Melbourne Office: Level 3, 171 La Trobe Street Melbourne VIC 3000";

      if (this.isWholesaleFundingGroup) {
        return this.value;
      }

      return this.value.filter((item) => item !== wholesaleOnlyAddress);
    },
    showCreditLicense() {
      return ["Award Mortgage", "Wholesale Funding Group"].includes(this.form.value[0]);
    },
    creditLicense() {
      const selectedBusiness = this.business.find((item) => item.name === this.form.value[0]);

      return selectedBusiness?.credit || this.ACL;
    },
    signatureIcons() {
      const iconFolder = this.isWholesaleFundingGroup ? "wfg/" : "";

      return {
        phone: require(`@/assets/${iconFolder}phone.png`),
        website: require(`@/assets/${iconFolder}website.png`),
        map: require(`@/assets/${iconFolder}map.png`),
        email: require(`@/assets/${iconFolder}email.png`),
        document: this.isWholesaleFundingGroup
          ? require("@/assets/wfg/credit_card.png")
          : require("@/assets/document.png"),
      };
    },
    selectedBusinessCardComponent() {
      const componentMap = {
        awardMortgage: "AwardMortgageBusinessCard",
        globalRealty: "GlobalRealtyBusinessCard",
      };

      return componentMap[this.selectedBusinessCard] || "AwardMortgageBusinessCard";
    },
  },

  methods: {
    async copyEmailSignature() {
      const elementToCopy = document.getElementById("showSection");

      if (!elementToCopy) {
        return;
      }

      const html = this.getCopyHtml(elementToCopy);
      const plainText = elementToCopy.innerText;

      try {
        this.copyHtmlWithExecCommand(html, plainText);
        console.log("Email signature copied.");
        return;
      } catch (copyEventError) {
        console.warn("Copy event failed, trying clipboard API.", copyEventError);
      }

      try {
        if (navigator.clipboard && window.ClipboardItem) {
          await navigator.clipboard.write([
            new window.ClipboardItem({
              "text/html": new Blob([html], { type: "text/html" }),
              "text/plain": new Blob([plainText], { type: "text/plain" }),
            }),
          ]);
        } else {
          this.copyHtmlWithSelection(html);
        }

        console.log("Email signature copied.");
      } catch (error) {
        this.copyHtmlWithSelection(html);
        console.log("Email signature copied with fallback.", error);
      }
    },
    getCopyHtml(elementToCopy) {
      const clonedElement = elementToCopy.cloneNode(true);
      const originalImages = elementToCopy.querySelectorAll("img");
      const clonedImages = clonedElement.querySelectorAll("img");

      clonedImages.forEach((image, index) => {
        const originalImage = originalImages[index];

        if (originalImage?.src) {
          image.setAttribute("src", originalImage.src);
        }

        if (this.isWholesaleFundingGroup && originalImage?.hasAttribute("data-wfg-icon")) {
          image.setAttribute("width", "18.39");
          image.setAttribute("align", "absmiddle");
          image.removeAttribute("hspace");
          image.removeAttribute("height");
          image.setAttribute("style", "width: 18.39px; height: auto; display: inline-block; vertical-align: middle; border: 0;");
        }

        if (this.isWholesaleFundingGroup && originalImage?.hasAttribute("data-wfg-logo")) {
          image.setAttribute("width", "700");
          image.removeAttribute("height");
          image.setAttribute("style", "width: 700px; max-width: 700px; height: auto; display: block; border: 0;");
        }
      });

      if (this.isWholesaleFundingGroup) {
        const nameContainer = clonedElement.querySelector("[data-name-container]");
        if (nameContainer) {
          const outlookColor = "#234193";
          nameContainer.setAttribute(
            "style",
            "font-family: Segoe UI; font-size: 14pt; font-weight: bold; color: #234193;"
          );
          nameContainer.innerHTML = `<b><font face="Segoe UI" size="4" color="${outlookColor}">${nameContainer.innerHTML}</font></b>`;
        }

        const positionContainer = clonedElement.querySelector("[data-position-container]");
        if (positionContainer) {
          const outlookPositionStyle = [
            "font-family: Segoe UI",
            "mso-ascii-font-family: Segoe UI",
            "mso-hansi-font-family: Segoe UI",
            "mso-bidi-font-family: Segoe UI",
            "font-size: 11pt",
            "font-weight: normal",
            "color: #000000",
            "line-height: normal",
          ].join("; ");

          positionContainer.setAttribute("style", outlookPositionStyle);
          positionContainer.innerHTML = `<font face="Segoe UI" style="font-size: 11pt; color: #000000;">${positionContainer.innerHTML}</font>`;
        }

        const wfgContactTable = clonedElement.querySelector("[data-wfg-contact-table]");
        if (wfgContactTable) {
          wfgContactTable.setAttribute(
            "style",
            "border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;"
          );
        }

        clonedElement.querySelectorAll("[data-wfg-icon-cell]").forEach((cell) => {
          cell.setAttribute("style", "padding: 0; width: 18.39px; vertical-align: middle;");
        });

        clonedElement.querySelectorAll("[data-wfg-contact-cell]").forEach((cell) => {
          cell.setAttribute(
            "style",
            "padding: 0 0 0 3px; padding-left: 3px; mso-padding-alt: 0 0 0 2.25pt; vertical-align: middle;"
          );
        });

        const contactTextStyle = [
          "font-family: Segoe UI",
          "mso-ascii-font-family: Segoe UI",
          "mso-hansi-font-family: Segoe UI",
          "mso-bidi-font-family: Segoe UI",
          "font-size: 11pt",
          "line-height: normal",
          "vertical-align: middle",
        ];

        clonedElement.querySelectorAll("[data-wfg-contact]").forEach((contactElement) => {
          const contactType = contactElement.getAttribute("data-wfg-contact");
          const isPhone = contactType === "phone";
          const isWebsite = contactType === "website";
          const fontWeight = isPhone ? "bold" : "normal";
          const contactColor = isPhone ? "#555555" : "#000000";
          const websiteTextStyle = isWebsite ? ["text-decoration: none", "mso-text-raise: 0pt"] : [];
          const style = [...contactTextStyle, `color: ${contactColor}`, `font-weight: ${fontWeight}`, ...websiteTextStyle].join("; ");
          const content = contactElement.innerHTML;
          const fontHtml = `<font face="Segoe UI" style="font-size: 11pt; color: ${contactColor};${isWebsite ? " text-decoration: none;" : ""}">${content}</font>`;

          contactElement.setAttribute("style", style);
          contactElement.innerHTML = isPhone ? `<b>${fontHtml}</b>` : fontHtml;
        });
      }

      return clonedElement.outerHTML;
    },
    copyHtmlWithSelection(html) {
      const container = document.createElement("div");
      const selection = window.getSelection();
      const range = document.createRange();

      container.setAttribute("contenteditable", "true");
      container.style.position = "fixed";
      container.style.left = "-9999px";
      container.style.top = "0";
      container.style.opacity = "0";
      container.innerHTML = html;
      document.body.appendChild(container);

      range.selectNodeContents(container);
      selection.removeAllRanges();
      selection.addRange(range);

      const copied = document.execCommand("copy");

      selection.removeAllRanges();
      document.body.removeChild(container);

      if (!copied) {
        throw new Error("Selection copy command failed.");
      }
    },
    copyHtmlWithExecCommand(html, plainText) {
      const handleCopy = (event) => {
        event.preventDefault();
        event.clipboardData.setData("text/html", html);
        event.clipboardData.setData("text/plain", plainText);
      };

      document.addEventListener("copy", handleCopy);
      const copied = document.execCommand("copy");
      document.removeEventListener("copy", handleCopy);

      if (!copied) {
        throw new Error("Copy command failed.");
      }
    },
    handleTemplateChange(value) {
      if (value[0] === 'General') {
        this.selectedTemplateIndex = 1;
        this.showSignature = true;
        this.headerText = "Email Signature/Template Generator";
        this.subHeaderText = "(Please fill out the form to automatically generate a signature)";
      } else if (value[0] === 'CC EDM') {
        this.selectedTemplateIndex = 2;
        this.showSignature = false;
        this.birthdayEDM = false;
        this.headerText = "Email Signature/Template Generator";
        this.subHeaderText = "(Please fill out the form to automatically generate a signature)";
      } else if (value[0] === 'CC EDM WFG') {
        this.selectedTemplateIndex = 3;
        this.birthdayEDM = false;
        this.showSignature = false;
        this.headerText = "Email Signature/Template Generator";
        this.subHeaderText = "(Please fill out the form to automatically generate a signature)";
      } else if (value[0] === 'CC EDM BIRTHDAY') {
        this.selectedTemplateIndex = 4;
        this.birthdayEDM = true;
        this.showSignature = false;
        this.headerText = "Email Signature/Template Generator";
        this.subHeaderText = "(Please fill out the form to automatically generate a signature)";
      } else if (value[0] === 'MKT SALES CARD') { // todo
        this.selectedTemplateIndex = 5;
        this.birthdayEDM = false;
        this.showSignature = false;
        this.headerText = "Business Card Generator";
        this.subHeaderText = "Please fill out the form to automatically generate your Business Card.";
      }
    },
    handleChange(value) {
      if (value[0]) {
        // if (value[1]) {
        //   this.business.forEach((item) => {
        //     if (item.name === value[0]) {
        //       this.showLogo = `logo/${item?.name}`;
        //       this.website = item.link;
        //     }
        //   });
        //   this.socials = this.business.find(
        //     (item) => item.name === value[0]
        //   ).socials;
        //   this.showBanner = "";
        // } else {
        this.business.forEach((item) => {
          if (item.name === value[0]) {
            this.showLogo = `logo/${item?.name}`;
            this.showBanner = item?.banner;
            this.socials = item?.socials;
            this.website = item.link;
          }
        });
        // }
      }
    },
  },
};
</script>

<style>
#app {
  margin: 5% 15% 0 15% !important;
}

#cutSection {
  width: 70% !important;
  margin: 30px auto;
}

.s_transfer {
  grid-column: span 3 !important;
  justify-content: space-around !important;
}

.fa-share {
  display: none !important;
}

.fa-arrow-down {
  display: block !important;
  text-align: center;
}

.header {
  font-size: 24px;
  font-weight: bold;
}

.main {
  display: block !important;
}

form.el-form.el-form--label-top {
  /* width: 40%; */
  position: relative;
  padding: 30px;
  margin-top: 30px;
  border: 1px dashed black;
  width: auto !important;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  margin-bottom: 40px;
}

.el-transfer-panel {
  /* width: 205px !important; */
  width: 40% !important;
}

.el-form-item__label {
  line-height: 10px !important;
}

.el-transfer__buttons {
  padding: 0 1% !important;
}

.el-button--primary.is-disabled {
  background-color: white !important;
  color: black !important;
  border: 1px solid rgb(163, 162, 162) !important;
}

.el-icon-arrow-left:before,
.el-icon-arrow-right:before {
  margin: -6px;
}

.infoSection {
  display: flex;
  align-items: center;
}

.formSection {
  border-left: 1px solid black;
  padding-left: 15px;
}
</style>
